// src/pages/ForgedMonoblock.jsx
import React from "react";
import { Link } from "react-router-dom";
import AutoVideo from "../components/AutoVideo";
import StyleTileGrid from "../components/StyleTileGrid";
import { MONOBLOCK_STYLES } from "../data/monoblockStyles";


export default function ForgedMonoblock() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-16 text-neutral-900">
      {/* ---- HERO: video + copy + Request button (same content you had) ---- */}
      <h1 className="text-3xl font-bold mb-6">Forged Monoblock</h1>

      <div className="grid md:grid-cols-2 gap-8 mb-10">
        <div className="rounded-2xl overflow-hidden border border-neutral-200">
          <AutoVideo
            srcMp4="/assets/video/monoblock.mp4"
            // poster="/assets/posters/monoblock.jpg"
            className="aspect-video"
          />
        </div>

        <div className="space-y-4">
          <p className="text-neutral-700">
            One-piece aerospace-grade forging for max rigidity and minimum weight. Most popular option for most cars,
            specifically if you are looking to reduce the rotational mass. Choose from Styles below or upload your own idea and watch us bring it to life. Every set is bespokely made for you and your car. We can also make Monoblock wheels that look like 2 or 3 piece wheels with or without hardware. See what we have created already for our other clients. 
   </p>

<ul className="list-disc list-inside text-neutral-800 mb-6">
    <li>6061-T6 aerospace-grade forged aluminum for superior strength</li>
    <li>17" - 30" Diameter</li>
    <li>Custom Offsets</li>
    <li>CenterLock, Floating, 3D and flat aluminum center caps</li>
    <li>Optional hardware styling for a 2- or 3-piece aesthetic</li>
    <li>LifeTime Structural Warranty*</li>
    <li>Average production time is 3-4 weeks, depending on the size and finishes.</li>

  </ul>


          <Link
            to="/build-your-custom-wheels"
            className="inline-block px-6 py-3 bg-black text-white rounded-xl font-semibold hover:bg-neutral-800 transition"
          >
            Request a Quote
          </Link>
        </div>
      </div>

      {/* ---- TILES: choose your style ---- */}
      <h2 className="text-2xl font-semibold mb-4">Choose Your Style</h2>
      <StyleTileGrid styles={MONOBLOCK_STYLES} />
    </section>
  );
}
